import config from '../../config';
import {
  ContentType,
  BreedContentType,
  BreedsContentType,
} from '../../content-types';

import type { BloodhoundDocument } from '../../content-types';

export interface ContentTypeRendererProps {
  document: BloodhoundDocument;
}

export function ContentTypeRenderer({ document }: ContentTypeRendererProps) {
  const documentType = document.type;

  switch (documentType) {
    case ContentType.breed: {
      return <BreedContentType document={document} />;
    }

    case ContentType.breeds: {
      return <BreedsContentType document={document} />;
    }

    default: {
      return exhaustiveCheck(documentType);
    }
  }
}

function exhaustiveCheck(contentType: never): null {
  if (config.get('env') === 'production') {
    return null;
  }

  throw new Error(
    `The content type: ${String(contentType)} has not yet been implemented`
  );
}
